module.exports = __webpack_public_path__ + "../resources/img/Web_Image_Battery.e9ceb531.svg";